import { AnyAction, configureStore, Action, isPlain } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { ThunkAction, ThunkDispatch } from "redux-thunk";

import { benefitApi } from "../api/benefitApi";
import { mailApi } from "../api/mailApi";
import { personsApi } from "../api/personsApi";
import { requestApi } from "../api/requestApi";
import rootReducer, { RootState } from "./rootReducer";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        isSerializable: (value: unknown) =>
          value instanceof Date ? true : isPlain(value),
      },
    }).concat(
      benefitApi.middleware,
      mailApi.middleware,
      personsApi.middleware,
      requestApi.middleware
    ),
});

export type AppDispatch = ThunkDispatch<RootState, undefined, AnyAction>;
export const useAppDispatch: () => AppDispatch = useDispatch;

export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>;

export default store;
